<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getPickingSupplyForSubcontracts"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-picking-supply-for-subcontract-number" label-cols-sm="4" label-cols-lg="3" label="Picking Supply For Subcontract No" label-for="filter-picking-supply-for-subcontract-number" size="sm" :model.sync="filter.pickingSupplyForSubcontractNumber" />
					<app-input-combobox-autocomplete :options="workOrderSupplySubContracts" optionsLabel="materialIssueNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Work Order Supply (W/O No)" id="filter-" size="sm" :model.sync="filter.workOrderSupplySubcontractId" @input="getWorkOrderSupplySubContracts" @focus="getWorkOrderSupplySubContracts" />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Document Status" id="filter-" size="sm" :model.sync="filter.documentStatusId" @input="getDocumentStatuss" @focus="getDocumentStatuss" />
					<app-input-datepicker-range  id="fieldset-material-issue-date" label-cols-sm="4" label-cols-lg="3" label="Material Issue Date" size="sm" :modelFrom.sync="filter.materialIssueDateFrom" :modelTo.sync="filter.materialIssueDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					</b-col>
					<!-- <b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="actionStatusOptions" optionLabel="name" optionKey="id" label-cols-sm="4" label-cols-lg="3" label="Action Status" id="filter-action-status" size="sm" :model.sync="filter.actionStatus" />
					</b-col> -->
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getPickingSupplyForSubcontracts"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Picking Supply For Subcontract</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown v-if="false" text="Action" class="m-md-2 btn-action-more" size="sm">
							<b-dropdown-item v-if="false" href="files/pickingsupplyforsubcontract/PickingSupplyForSubcontract.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
							<b-dropdown-item v-if="false" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="false" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Start Scan</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Start Scan</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button v-if="true && isEnableDefaultFeature" class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
					
					<b-overlay v-if="isShowDeleteButton && isEnableDefaultFeature"
							   :show="isDeleteBusy"
							   rounded
							   opacity="0.6"
							   spinner-small
							   spinner-variant="primary"
							   class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-pickingsupplyforsubcontract" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="pickingSupplyForSubcontracts" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="pickingSupplyForSubcontracts.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
				<b-th stacked-heading="Picking Supply For Subcontract No" class="table-filter">
					<b-form-input id="input-picking-supply-for-subcontract-number-table" @input="getPickingSupplyForSubcontractsWithoutLoading" v-model="filter.pickingSupplyForSubcontractNumber" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Work Order Supply (W/O No)" class="table-filter">
					<v-select append-to-body label="materialIssueNumber" :options="workOrderSupplySubContracts" :value="filter.workOrderSupplySubcontractId" :reduce="item => item.id" v-model="filter.workOrderSupplySubcontractId" :filterable="true" @input="getPickingSupplyForSubcontractsWithoutLoading" @search="getWorkOrderSupplySubContracts"></v-select>
				</b-th>
				<b-th stacked-heading="Document Status" class="table-filter">
					<v-select append-to-body label="name" :options="documentStatuss" :value="filter.documentStatusId" :reduce="item => item.id" v-model="filter.documentStatusId" :filterable="true" @input="getPickingSupplyForSubcontractsWithoutLoading" @search="getDocumentStatuss"></v-select>
				</b-th>
				<b-th stacked-heading="Material Issue Date" class="table-filter">
					<b-form-datepicker boundary="viewport" placeholder="" id="input-material-issue-date-from-table" reset-button @input="getPickingSupplyForSubcontractsWithoutLoading" v-model="filter.materialIssueDateFrom" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
					<b-form-datepicker boundary="viewport" placeholder="" id="input-material-issue-date-to-table" reset-button @input="getPickingSupplyForSubcontractsWithoutLoading" v-model="filter.materialIssueDateTo" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
				</b-th>
				<b-th stacked-heading="Action Status" class="table-filter">
				</b-th>

					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(pickingsupplyforsubcontractnumber)="row">

                <a @click="showDetail(row.item)" class="a-link-detail">
							{{ row.item.pickingSupplyForSubcontractNumber != null && row.item.pickingSupplyForSubcontractNumber != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.pickingSupplyForSubcontractNumber.slice(0, 30) + (row.item.pickingSupplyForSubcontractNumber.length > 30 ? "..." : "" ) : row.item.pickingSupplyForSubcontractNumber : "" }}
						</a>
            
					</template>

			<template v-slot:cell(workOrderSupplySubcontract)="row">
				{{ row.item.workOrderSupplySubcontract != null ? row.item.workOrderSupplySubcontract.materialIssueNumber : "" }}
			</template>
			<template v-slot:cell(documentStatus)="row">
				{{ row.item.documentStatus != null ? row.item.documentStatus.name : "" }}
			</template>
			<template v-slot:cell(materialIssueDate)="row">
				{{ row.item.materialIssueDate | moment("DD-MMM-YYYY") }}
			</template>
			<template v-slot:cell(actionStatus)="row">
				<div class="two-item">
					<span class="d-stack-none">{{ row.item.actionStatus }}</span>
					<span :class="'d-stack-none '+getRectangleClass(row.item.actionStatus)"></span>
				</div>
			</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2" v-if="isShowDeleteButton  && isEnableDefaultFeature">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<span :class="getRectangleClass(row.item.actionStatus)"></span>

							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.documentStatusId" label="Document Status" :selected="row.item.documentStatus != null ? row.item.documentStatus.name : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-datepicker  id="fieldset-material-issue-date" label-cols-lg="12"  label="Material Issue Date" size="sm" :model.sync="row.item.materialIssueDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(pickingSupplyForSubcontractsPaging != null ? pickingSupplyForSubcontractsPaging.dataCount : 0)"
									:per-page="(pickingSupplyForSubcontractsPaging != null ? pickingSupplyForSubcontractsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    
    .two-item {
        display: flex;
        padding: 10px;
        justify-content: space-between;
        align-items: center;
    }
    .rectangle {
        width: 30px;
	    height: 30px;
    }

    @media screen and (max-width: 400px) {
	    .two-item {
	        display: none;
        }
    }

    .rectangle-danger {
        background-color: #DC3545;
        background-size: 20px 20px;
        display: block;
        width: 20px;
        height: 20px;
        content: "";
        margin-bottom: 10px;
    }
    .rectangle-warning {
        background-color: #FFC107;
        background-size: 20px 20px;
        display: block;
        width: 20px;
        height: 20px;
        content: "";
        margin-bottom: 10px;
    }
    .rectangle-success {
        background-color: #28A745;
        background-size: 20px 20px;
        display: block;
        width: 20px;
        height: 20px;
        content: "";
        margin-bottom: 10px;
    }
    .rectangle-not-found {
        background-color: #D3D3D3;
        background-size: 20px 20px;
        display: block;
        width: 20px;
        height: 20px;
        content: "";
        margin-bottom: 10px;
    }
                

    ::v-deep #table-list-pickingsupplyforsubcontract.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

	::v-deep #table-list-pickingsupplyforsubcontact.b-table>thead>tr>th {
		background: #e28b29;
	}

    ::v-deep #table-list-pickingsupplyforsubcontract.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import PickingSupplyForSubcontract from '@/models/PickingSupplyForSubcontract/PickingSupplyForSubcontract';
import PickingSupplyForSubcontractList from '@/models/PickingSupplyForSubcontract/PickingSupplyForSubcontractList';
import PickingSupplyForSubcontractFilter from '@/filters/PickingSupplyForSubcontract/PickingSupplyForSubcontractFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import WorkOrderSupplySubContractFilter from '@/filters/WorkOrderSupplySubContract/WorkOrderSupplySubContractFilter';
import WorkOrderSupplySubContract from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContract';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import WorkOrderSupplySubContractDetailFilter from '@/filters/WorkOrderSupplySubContract/WorkOrderSupplySubContractDetailFilter';
import WorkOrderSupplySubContractDetail from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContractDetail';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import UserInfo from '@/models/UserInfo/UserInfo';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		PickingSupplyForSubcontract, 
		PickingSupplyForSubcontractList, 
		PickingSupplyForSubcontractFilter, 
		AppLabel,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"pickingSupplyForSubcontractNumber": {}, "class" : "th-picking-supply-for-subcontract-number first-child", "label" : "Picking Supply For Subcontract No", key: 'pickingSupplyForSubcontractNumber', sortable: true}, 
				{"workOrderSupplySubcontract": {}, "class" : "th-work-order-supply-subcontract", "label" : "Work Order Supply (W/O No)", key: 'workOrderSupplySubcontract', sortable: true}, 
				{"documentStatus": {}, "class" : "th-document-status last-child", "label" : "Document Status", key: 'documentStatus', sortable: true}, 
				{"materialIssueDate": {}, "class" : "th-material-issue-date d-stack-none", "label" : "Material Issue Date", key: 'materialIssueDate', sortable: true}, 
				{"actionStatus": {}, "class" : "th-actionStatus", "label" : "Action Status", key: "actionStatus", sortable: true}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isEnableDefaultFeature : false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			pickingSupplyForSubcontracts: [],
			pickingSupplyForSubcontractsPaging: {},
			workOrderSupplySubContracts : [],
			documentStatuss : [],
			pickingSupplyForSubcontractDetails : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: true,
			
            actionStatusOptions: [
                {id: 1, name: 'O P E N'},
				{id: 2, name: 'I N_ P R O G R E S S'},
				{id: 3, name: 'C L O S E D'},

            ],
                    
		}
	},	methods : {

		showDetail(item){
			this.$router.push({ name: this.getTargetView(item), params : { id: item.id } });
		},
		getTargetView(item){
			var targetView = item.documentStatusId!=null && (item.documentStatusId.toUpperCase() == "OPEN" || item.documentStatusId.toUpperCase() == "IN_PROGRESS") ? 'pickingsupplyforsubcontractscan' : 'pickingsupplyforsubcontractdetail';
			return targetView.toLowerCase();
		},
		getPickingSupplyForSubcontracts : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			PickingSupplyForSubcontract.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.pickingSupplyForSubcontracts = result.data
					this.pickingSupplyForSubcontractsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getPickingSupplyForSubcontractsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			PickingSupplyForSubcontract.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.pickingSupplyForSubcontracts = result.data
					this.pickingSupplyForSubcontractsPaging = result
				}
			})
			.catch(error => {});
		},
		getWorkOrderSupplySubContracts : async function(input) {
			let filter = new WorkOrderSupplySubContractFilter();
			if (input != undefined) {
				filter.materialIssueNumber = input;
			}
			await WorkOrderSupplySubContract.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderSupplySubContracts = result.data
				}
			})
			.catch(error => {});
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			await DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
			})
			.catch(error => {});
		},
		getRectangleClass(actionStatus) {
			let cls = 'rectangle';
			if (actionStatus == 'OPEN') {
				cls += ' rectangle-danger';
			} else if(actionStatus == 'IN_PROGRESS') {
				cls += ' rectangle-warning';
			} else if(actionStatus == 'DONE' || actionStatus == 'CLOSED'){ 
				cls += ' rectangle-success';
			}else { 
				cls += ' rectangle-not-found';
			}
			return cls;
		},

		resetFilter() {
			this.filter = new PickingSupplyForSubcontractFilter();
			this.getPickingSupplyForSubcontracts();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getPickingSupplyForSubcontracts();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				PickingSupplyForSubcontract.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			PickingSupplyForSubcontract.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			PickingSupplyForSubcontract.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},
		createData() {
			this.isCreateBusy = true;
			PickingSupplyForSubcontract.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'pickingsupplyforsubcontractedit';
						if(this.isScannerMode) {
							createRoute = 'pickingsupplyforsubcontractscan';
						}

						this.$router.push({ name: createRoute, params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			PickingSupplyForSubcontract.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'pickingsupplyforsubcontractedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			PickingSupplyForSubcontract.deleteData(this, id).then(result => {
				if (result)
				{
					this.getPickingSupplyForSubcontracts();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				PickingSupplyForSubcontract.deleteMultipleData(this).then(result => {
					this.getPickingSupplyForSubcontracts();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tablePickingSupplyForSubcontractParent = document.getElementById('table-list-pickingsupplyforsubcontract').parentNode;
			tablePickingSupplyForSubcontractParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tablePickingSupplyForSubcontractParent.scrollWidth - tablePickingSupplyForSubcontractParent.offsetWidth) == Math.ceil(tablePickingSupplyForSubcontractParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tablePickingSupplyForSubcontractParent = document.getElementById('table-list-pickingsupplyforsubcontract').parentNode;
			tablePickingSupplyForSubcontractParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tablePickingSupplyForSubcontractParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new PickingSupplyForSubcontractFilter();
		this.getWorkOrderSupplySubContracts()
		this.getDocumentStatuss()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Picking Supply For Subcontract"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getPickingSupplyForSubcontracts();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getPickingSupplyForSubcontracts();
			}
		},
		sortDesc: {
			handler: function() {
				this.getPickingSupplyForSubcontracts();
			}
		},
		currentPage: {
			handler: function() {
				this.getPickingSupplyForSubcontracts();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getPickingSupplyForSubcontracts();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				PickingSupplyForSubcontract.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "pickingsupplyforsubcontractindex") {
					this.getPickingSupplyForSubcontractsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "picking_supply_for_subcontract").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
